import React, { FC } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import ReactSlider from './ReactSlider';
import Handler from './components/Handler';
import Track from './components/Track';
import { SliderProps } from './props';
import { isMarkedTrack } from './helpers/isMarkedTrack';

const Root = styled.div`
  position: relative;
  height: 1rem;
  :before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 100px;
    height: 0.25rem;
    background-color: ${globalTheme.palette.secondary};
  }
`;

const SliderNormal: FC<React.PropsWithChildren<SliderProps>> = ({ showTooltip, tooltipPlacement, renderValue, disabled, ...props }) => (
  <Root data-test="slider">
    <ReactSlider
      {...props}
      disabled={disabled}
      ariaLabel="Make selections from a range of values"
      renderTrack={(props, state) => <Track {...props} selected={state && isMarkedTrack(state)} disabled={disabled} />}
      renderThumb={(props, state) => {
        const value = renderValue ? renderValue(props, state) : state.valueNow;
        return <Handler {...{ showTooltip, tooltipPlacement, ...props }} value={value} disabled={disabled} data-test-label={value} />;
      }}
    />
  </Root>
);

export default SliderNormal;
